var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSittingIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6710_10191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6152 20.2053C23.8671 25.2655 40.3604 23.7321 35.601 47.2953C39.0087 32.7903 55.6865 44.6391 57.8508 38.5303C60.32 31.5609 46.8829 36.9258 46.4397 34.8765C45.4409 30.2579 60.1743 35.2631 60.11 29.1384C60.0433 22.7814 47.9943 30.7815 47.2527 28.4746C46.2934 25.4905 60.2069 23.387 60.3668 20.4066C60.7349 13.5455 49.6325 22.1286 49.1139 21.1136C47.9345 18.8049 63.3175 13.196 59.8391 9.72857C53.9344 3.8427 51.6945 15.845 49.4825 15.8019C47.4629 15.7626 51.8809 3.41475 45.0891 4.19524C38.8424 4.91308 48.504 19.5127 45.0526 22.4175C44.0744 23.2407 45.0138 10.9163 38.9348 13.4788C34.0064 15.5562 40.9094 23.2079 40.4705 27.0141C40.1522 29.7751 37.3692 17.4554 32.6152 20.2053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8323 20.2053C42.5804 25.2655 26.0871 23.7321 30.8465 47.2953C27.4388 32.7903 10.761 44.6391 8.59672 38.5303C6.12755 31.5609 19.5646 36.9258 20.0078 34.8765C21.0066 30.2579 6.27322 35.2631 6.33751 29.1384C6.40425 22.7814 18.4533 30.7815 19.1948 28.4746C20.1541 25.4905 6.2406 23.387 6.08069 20.4066C5.71257 13.5455 16.815 22.1286 17.3336 21.1136C18.513 18.8049 3.12999 13.196 6.60845 9.72857C12.5131 3.8427 14.753 15.845 16.965 15.8019C18.9846 15.7626 14.5666 3.41475 21.3584 4.19524C27.6051 4.91308 17.9435 19.5127 21.395 22.4175C22.3731 23.2407 21.4337 10.9163 27.5127 13.4788C32.4411 15.5563 25.5381 23.2079 25.977 27.0141C26.2953 29.7751 29.0783 17.4554 33.8323 20.2053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13562 56.8651L9.58326 41.9207H56.4281L60.0565 56.8651H5.13562Z",
    fill: "#909DF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.13562,
    y: 56.8652,
    width: 54.9208,
    height: 7.13489,
    fill: "#6476F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.738 50.5886L31.9156 45.204C28.7733 44.3349 26.2599 43.7319 21.3562 44.8951L18.9772 50.5886C24.5611 49.5649 27.8688 49.8157 30.738 50.5886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7148 50.5885L31.8576 45.204C34.9998 44.3349 36.8354 43.8921 41.7391 45.0553L44.1181 50.7488C38.5342 49.725 33.584 49.8156 30.7148 50.5885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.2077,
    cy: 17.6125,
    r: 4.23405,
    fill: "#223BF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.012 16.4785C34.1526 17.1289 35.5652 17.3551 35.9791 16.7344",
    stroke: "white",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.3235,
    cy: 16.4637,
    r: 0.407427,
    transform: "rotate(-9.11976 37.3235 16.4637)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5802,
    cy: 15.9969,
    r: 0.407427,
    transform: "rotate(-9.11976 32.5802 15.9969)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9627 14.4225C36.7415 14.0908 36.4632 13.5198 35.7328 13.4167C36.8384 13.16 37.7664 13.6694 37.9243 14.0484C38.0823 14.4275 37.9243 15.2358 37.2391 15.3701C37.2326 15.2319 37.1839 14.7541 36.9627 14.4225Z",
    fill: "#1CDBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6829 22.5405C59.6512 22.5405 57.8037 48.5316 49.3705 49.7364C40.9373 50.9411 36.2403 49.628 35.2528 49.3305C35.2528 49.3305 34.8024 49.1915 34.7773 48.5908C34.756 48.0793 34.6012 47.9942 34.6012 47.446C34.6012 46.8918 34.5502 46.8783 34.5502 46.3447C34.5502 45.8788 34.8181 45.7402 34.9494 45.7003C34.8094 45.7258 34.5056 45.7538 34.4436 45.5337C34.3625 45.2454 34.3807 44.6767 35.3835 44.3707C36.3863 44.0648 45.893 44.411 46.6525 42.892C46.753 42.6909 46.8467 42.4463 46.9339 42.1664H21.4688C21.7855 42.7554 22.2287 43.1484 22.837 43.2532C25.818 43.7672 28.4573 44.0703 28.8289 44.2006C29.2005 44.3309 29.38 44.3404 29.5079 44.7338C29.6118 45.053 29.1964 45.2367 29.036 45.2946C29.1528 45.2693 29.4059 45.2826 29.5079 45.8219C29.6427 46.5339 29.5079 46.4069 29.5079 46.9537C29.5079 47.5006 29.4848 47.5181 29.4132 47.8147C29.2853 48.3454 29.5564 48.6051 29.1183 49.0133C28.6802 49.4216 28.2091 49.3844 26.5762 49.6071C24.9434 49.8298 14.3378 49.8174 12.528 45.9263C10.4721 41.5061 12.528 24.3463 29.508 22.5405H38.6829Z",
    fill: "#223BF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2695 33.9507C20.6206 36.4702 19.8494 40.9367 21.4986 42.0056",
    stroke: "#EEF0FE",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8215 42.1537C47.4342 40.1049 47.9671 35.9592 47.4341 34.4194",
    stroke: "#EEF0FE",
    strokeWidth: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6710_10191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSittingIllustration);
export default __webpack_public_path__ + "static/media/sitting-illustration.2f9d20588161a2939adac01391ba2a66.svg";
export { ForwardRef as ReactComponent };